import { NativeModules, Platform } from 'react-native';

const LINKING_ERROR =
  `The package 'react-native-task-auto' doesn't seem to be linked. Make sure: \n\n` +
  Platform.select({ ios: "- You have run 'pod install'\n", default: '' }) +
  '- You rebuilt the app after installing the package\n' +
  '- You are not using Expo managed workflow\n';

const TaskAuto = NativeModules.TaskAuto
  ? NativeModules.TaskAuto
  : new Proxy(
      {},
      {
        get() {
          throw new Error(LINKING_ERROR);
        },
      }
    );

export function multiply(a: number, b: number): Promise<number> {
  
  return TaskAuto.multiply(a, b);
}

export { default as self } from './thread/self';
export { default as Thread } from './thread/Thread';